import { useContext, useLayoutEffect, useState } from 'react'
import { media } from '../../../dataSets/media';
import { AppContext } from '../../../contextApi/ContextApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ClientContext } from '../../../contextApi/ClientContext';

export default function BrandItem({item, isDashboard, setDisplay}) {
    const {currentWebsite, primary_color, secondary_color, accent_color, fetchImage, setToastMessage, messagesOptions} = useContext(AppContext);
    const {moveToProductPage} = useContext(ClientContext);
    const discountCalc = parseFloat(item.price/100) * (100-item.disValue);
    const [imgUrl,setImgUrl] = useState(media.webingoLogo);
    const nav = useNavigate();
    const params = useParams();

    useLayoutEffect(()=>{
        fetchImage(currentWebsite, item, setImgUrl);
    },[item])
    
    return (
        <div className='brandItem' dir='rtl' style={{backgroundColor:primary_color, color:accent_color, border:`0.5px solid ${accent_color}`}} onClick={()=>{moveToProductPage(nav, currentWebsite, params, item, setToastMessage, messagesOptions, isDashboard, setDisplay)}}>
            <div className='brandItem_subDiv' dir='ltr'>
                <img src={imgUrl} alt='brand item image'/>
                {item.hasDiscount && <div className="onSaleRibbon" style={{backgroundColor:accent_color, color:primary_color, border:`0.5px solid ${primary_color}`, textShadow:`1px 1px 1px ${secondary_color}`}}>
                    <div className='onSaleRibbon_sub_valueOff'>
                        <div className='onSaleRibbon_disValue'><p>{item.disValue}</p><span>%</span></div>
                        <div className='onSaleRibbon_off'>Off</div>
                    </div>
                    <div className='onSaleRibbon_sub_onSale' dir='rtl'>במבצע!</div>
                </div>}
            </div>
            <div className='brandItem_subDiv'>
                <p><span>שם המוצר: </span>{item.name.lengt > 18 ? `${item.name.slice(0,18)}...` : item.name}</p>
                <p><span>תיאור: </span>{item.desc.length>70 ? `${item.desc.slice(0,70)}...` : item.desc}</p>
                <p>
                    <span>מחיר: </span>{item.hasDiscount ? (
                        <>
                            {discountCalc.toFixed(2)}₪{" "}
                            <span style={{ textDecoration: "line-through", opacity: 0.7 }}>
                                {item.price}₪
                            </span>
                        </>
                    ) : (<>{discountCalc.toFixed(2)}₪</>)}
                </p>
            </div>
        </div>
    )
}
